var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"analysis-data"},[_c('div',{attrs:{"className":"name"}},[_vm._v(" "+_vm._s(_vm.data.measuredValue)+" "+_vm._s(_vm.data.analysisType.name)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }